/**
 * Visit start / end / cancel shared by the patient chart and the Offline Visit Workspace
 * (Phase 16C C6). The services decide online vs queued; this hook only adds the app-wide
 * "visit state changed" signal so the bar, My Day and the board refresh.
 */
import { useCallback } from 'react';
import { cancelVisit, endVisit, startVisit, EndVisitPayload, StartVisitContext, StartVisitPayload } from '../../services/patientmr/visits.service';
import type { CancelVisitRequest, Visit } from '../../dtos/patientmr/visit.dto';
import { VISIT_STATE_CHANGED_EVENT } from '../../constants/navigationEvents';

const changed = () => { if (typeof window !== 'undefined') window.dispatchEvent(new Event(VISIT_STATE_CHANGED_EVENT)); };

export function useVisitActions() {
  const start = useCallback(async (payload: StartVisitPayload, context?: StartVisitContext): Promise<Visit> => {
    const visit = await startVisit(payload, context);
    changed();
    return visit;
  }, []);

  const end = useCallback(async (patientId: string, visitId: string, data: EndVisitPayload): Promise<Visit> => {
    const visit = await endVisit(patientId, visitId, data);
    changed();
    return visit;
  }, []);

  const cancel = useCallback(async (patientId: string, visitId: string, payload: CancelVisitRequest): Promise<Visit> => {
    const visit = await cancelVisit(patientId, visitId, payload);
    changed();
    return visit;
  }, []);

  return { start, end, cancel };
}

export default useVisitActions;
